(function() {
    'use strict';
 
 
a3_pilot_reports.service("UtilsService", UtilsService);

/* @ngInject */ 
function UtilsService() {
											
	return {
		/**
		 * Convert content length to fixed string
		 * @static
		 * @param {Number} n - number of byte kibibyte or mibi..., cannot not be NaN, indefinite or negative
		 * @param {Number} [f=0] - max fraction digits in range of 0..20
		 * @param {Number} [e=0] - exponent based 1024, Math.pow(1024,e) stands for the unit of n
		 * @return {String}
		 * @throws {RangeError}
		 */
		toSizeString: function (n,f,e){
			n=parseFloat(n);
			f>>>=0;
			e>>>=0;
			if(n!==n||1/n<0||1/n===-1/n||f<0||f>20||e<0){
				throw new RangeError("One of the three argument (number, fraction, exponent) is out of range");
			}
			var kibi=1024,mibi=1048576,gibi=1073741824,tebi=1099511627776;
			var v,u;
			n*=Math.pow(1024,e);
			if(n<kibi){
				v=n.toFixed(0);
				u="B";
			}else if(n<mibi){
				v=(n/kibi).toFixed(f);
				u="KB";
			}else if(n<gibi){
				v=(n/mibi).toFixed(f);
				u="MB";
			}else if(n<tebi){
				v=(n/gibi).toFixed(f);
				u="GB";
			}else{
				v=(n/tebi).toFixed(f);
				u="TB";
			}
			return v+""+u;
		}
	}
}
 
 })();   